import balanceScale from "@/../../hypetrain/static/img/balance-scale.png";
import bullseye from "@/../../hypetrain/static/img/bullseye.png";
import earth from "@/../../hypetrain/static/img/earth.png";
import life from "@/../../hypetrain/static/img/life.png";
import sparkles from "@/../../hypetrain/static/img/sparkles.png";
import { SITE_NAME } from "@/css/constants";
import { MarketingPageBenefits, MarketingPageConfig } from "@/types/marketing";

import { CTAMini } from "./CTAMini";

const options: MarketingPageConfig = {
  page: "LIFE_COACHING",
  color: "#2FACBC",
  metaTitle: `Online Life Coaching - ${SITE_NAME}`,
  metaDescription:
    "Work 1:1 with a life coach to maximize your full potential, overcome obstacles, set new goals, and reach your desired results.",
  metaImage: "https://placement-pub.s3.us-east-2.amazonaws.com/life-meta.png",
  defaultHeadline: "Life Coaching",
  defaultSubHeader:
    "Work 1:1 with a coach to maximize your full potential, overcome obstacles, set new goals, and reach your desired results.",
  benefitsHeadline: "Start improving your life today",
  ctaText: "Unlock your full potential",
  pricingIntro: "First session is only $29",
  audience: "D2C",
  serviceType: "session",
  specialtySlug: "life-coaching",
  FAQCategory: "Basics",
  marketingVideoId: 673987272,
  background: "linear-gradient(139deg, #0c5595 0%, #00b8c7 100%)",
  brandBg: "rgb(0, 80, 108)",
  heroGraphic: life,
  heroGraphicWidth: "500px",
  playDark: true,
  useCases: [
    "feedback",
    "anger",
    "imposter-syndrome",
    "conflict",
    "work-life",
    "parenting",
    "emotion",
    "find-direction",
  ],
  pricingCTA: <CTAMini />,
};

const benefits: MarketingPageBenefits = {
  title: "Lead a Purposeful Life",
  subtitle: "Create the life you want with a coach on your side",
  items: [
    {
      title: "Navigate Through Change",
      description: (
        <>
          Face the future with a positive mindset and the tools you need to
          succeed.
        </>
      ),
      photo: earth,
      bgColor: "#EBF3FD",
    },
    {
      title: "Organize Your Life",
      description: (
        <>
          Your coach will help you stay organized even during times of stress
          and transition.
        </>
      ),
      photo: sparkles,
      bgColor: "#FDF7E9",
    },
    {
      title: "Achieve Your Goals",
      description: (
        <>
          Discover your values, articulate your goals, and chart your course.
          With a coach, it's possible.
        </>
      ),
      photo: bullseye,
      bgColor: "#FEF0ED",
    },
    {
      title: "Sharpen Your Focus",
      description: (
        <>
          Find clarity through the transformative partnership you get when
          working with a coach.
        </>
      ),
      photo: balanceScale,
      bgColor: "#E9F7EF",
    },
  ],
};

export default {
  options,
  benefits,
};
